import { TransformItemsStructure } from './transformItemsStructure'

export const getStandardRouteItem = (
  pathname: string,
  allItems: TransformItemsStructure[],
): TransformItemsStructure | undefined => {
  return allItems.find((item) => {
    return item?.to && pathname.startsWith(item.to)
  })
}
